import type { CartValidationErrorDetails, ItemsListItem } from '../../../types';

export const parseStockErrors = (
    errors: CartValidationErrorDetails[],
    itemsList: ItemsListItem[]
) =>
    errors
        ?.filter(({ errorCode }) =>
            [
                'cart.checkout.outofstock',
                'cart.checkout.insufficientstock',
            ].includes(errorCode)
        )
        .map(error => {
            const itemInCart = itemsList.find(
                ({ id: itemId }) => itemId === error.lineItemId
            );

            return itemInCart
                ? {
                      ...error,
                      fulfillmentMethod: itemInCart.fulfillmentMethod,
                  }
                : null;
        })
        .filter(Boolean) || [];
